import { Component } from '@theme/component';

class WachstoriaPrivacyControls extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    super.disconnectedCallback();
  }

  onClick = (event) => {
    if (event.target instanceof Element && event.target.closest('.ws-cookie-settings')) this.showPreferences();
  };

  async showPreferences() {
    const message = this.querySelector('[role="status"]');
    try {
      if (!window.privacyBanner?.showPreferences) throw new Error('Cookie preferences unavailable');
      await window.privacyBanner.showPreferences();
      if (message) message.hidden = true;
    } catch {
      if (message) message.hidden = false;
    }
  }
}

if (!customElements.get('wachstoria-privacy-controls')) {
  customElements.define('wachstoria-privacy-controls', WachstoriaPrivacyControls);
}
